<template>
  <Modal
    v-bind="$attrs"
    persistent
  >
    <v-card slot="outer-body">
      <v-card-text class="pt-5 d-flex flex-column justify-center align-center">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <span class="pt-5 body-1">Aguarde...</span>
      </v-card-text>
    </v-card>
  </Modal>
</template>

<script>
export default {
  name: 'ModalLoading',
  components: {
    Modal: () => import('@/components/shared/Modal2')
  }
}
</script>

<style>

</style>